import { BankID, GeneralInfo } from 'components/brikks/home/MyHome/components/LivingInfoModal/components/LivingGeneralInfo/components';

export const GeneralInfoOptions = [
  {
    menu: 'aboutYourLandlord',
    submenus: [
      { title: 'generalInfo', content: GeneralInfo },
    ],
  },
  {
    menu: 'eIDAndSignatures',
    submenus: [
      { title: 'bankID', content: BankID },
    ],
  },
];
